module.exports = __webpack_public_path__ + "static/media/ProximaNovaBold.8ecbf861.ttf";